import type { FC, PropsWithChildren } from "react";
import { Link } from "react-router-dom";

import type { LinkWrapperProps } from "@jti/core-components/components/LinkBehaviour";
import { isAbsoluteUrl } from "@jti/fe-common";

export const ReactRouterLinkWrapper: FC<PropsWithChildren<LinkWrapperProps>> = ({ children, href, ...props }) => {
  if (!href || isAbsoluteUrl(href)) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} {...props}>
      {children}
    </Link>
  );
};
